import { useProductPositionProductInformationQuery } from "entities/product-positions/graphql/queries.generated"
import { useEnrichedProductInformation } from "entities/products/model/useEnrichedProductInformation"

interface UseProductPositionProductInformationArgs {
  id: string
  skip?: boolean
}

export function useProductPositionProductInformation({
  id,
  skip
}: UseProductPositionProductInformationArgs) {
  const { data, loading } = useProductPositionProductInformationQuery({
    variables: { id },
    skip
  })

  const productInformation = useEnrichedProductInformation(
    data?.productPositionProductInformation
  )

  return { productInformation, isLoading: loading }
}
